import React from 'react';
import type { ItemBrand } from './types';

interface Props {
  loading: boolean;
  brand: ItemBrand | null;
  onChange: (b: ItemBrand) => void;
  onSave: () => void;
}

const EditBrandModal: React.FC<Props> = ({ loading, brand, onChange, onSave }) => (
  <div className="modal fade" id="edit_brand" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Edit Item Brand</h5>
          <button className="btn-close custom-btn-close border p-1 me-0 text-dark" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label className="col-form-label">Brand Name <span className="text-danger">*</span></label>
            <input
              type="text" className="form-control" value={brand?.brandName || ''}
              onChange={(e) => brand && onChange({ ...brand, brandName: e.target.value })}
            />
          </div>
          <div className="mb-0">
            <label className="col-form-label">Description <span className="text-danger">*</span></label>
            <input
              type="text" className="form-control" value={brand?.description || ''}
              onChange={(e) => brand && onChange({ ...brand, description: e.target.value })}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary me-2" data-bs-dismiss="modal">Cancel</button>
          <button className="btn btn-success" data-bs-dismiss="modal" onClick={onSave} disabled={loading}>
            {loading ? <span className="spinner-border spinner-border-sm me-2" role="status" /> : 'Save'}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default EditBrandModal;
